// file-upload.component.ts
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
})
export class FileUploadComponent {
  @Input() accept = '';

  @Input() text = '';

  @Input() icon = '';

  @Output() fileSelected = new EventEmitter<File>();

  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement?.files?.length) {
      this.fileSelected.emit(inputElement.files[0]);
      inputElement.value = '';
    }
  }
}
